import { useNavigate } from "react-router-dom";
import useExchangePortalAxios from "../utils/axios";
import { useRef } from "react";
import {useDispatch} from "react-redux";
import {resetResponseState} from "../features/responseSlice";
import { clearNotifications } from "../features/webSocketSlice";

const useLogout = () => {
  const navigate = useNavigate();
  const ExchangePortalClient = useExchangePortalAxios();
  const dispatch = useDispatch();
  const isLoggingOut = useRef(false);

  const logout = async () => {
    if (isLoggingOut.current) return;
    isLoggingOut.current = true;

    await ExchangePortalClient.post(`/v1/Auth/LogOut`, {
      SessionID: sessionStorage.getItem("SessionID"),
    }).finally(() => {
      sessionStorage.clear();
      dispatch(resetResponseState());
      dispatch(clearNotifications());
      navigate("/", { replace: true });
    });
  };

  return {
    logout,
  };
};

export default useLogout;
